import { useRecoilState } from 'recoil'

import { bgmState } from '../recoil/atoms/appAtom'

export const useRecoilBgm = () => {
  const [bgm, setBgm] = useRecoilState(bgmState)
  return {
    bgm: bgm,
    setBgm: setBgm,
  }
}
